import React, { useState } from "react";
import { Box, useTheme } from "@mui/material";
import SimplePageHeader from "./Components/Navigation/SimplePageHeader";
import UserSettings from "./Components/User/UserSettings"; // Import the UserSettings component
// import AdminKnowledgeBase from "./Components/Settings/AdminKnowledgeBase"; // Import the AdminKnowledgeBase component
// import { faAppStoreIos } from "@fortawesome/free-brands-svg-icons";
// import { faBell, faCog, faQuestionCircle, faTools, faUserCircle } from "@fortawesome/free-solid-svg-icons";
// import {  ref, set } from "firebase/database";
// import { db } from "./firebase";
import KnowledgeBaseSettings from "./Components/KnowledgeBase/KnowledgeBaseSettings";

function SettingsPage() {
  const theme = useTheme();
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchChange = (term) => {
    setSearchTerm(term);
  };

//   const knowledgeBaseData = [
//     {
//       category: "Applications",
//       icon: faAppStoreIos,
//       items: [
//         {
//           question: "How do I add a new application?",
//           answer:
//             "To add a new application, click on the 'Add New Application' button and fill out the required fields, including name, icon URL, download URL, and installation parameters.",
//         },
//         {
//           question: "How do I edit an application?",
//           answer:
//             "To edit an existing application, click the pencil icon next to the application you want to modify. You can update details such as the name, icon, and installation parameters.",
//         },
//         {
//           question: "How do I delete an application?",
//           answer:
//             "To delete an application, click the trash icon next to the application you want to remove. Confirm the deletion in the pop-up dialog. Note that this action cannot be undone.",
//         },
//       ],
//     },
//     {
//       category: "Settings",
//       icon: faCog,
//       items: [
//         {
//           question: "What are company settings?",
//           answer:
//             "Company settings control various system preferences such as disabling Cortana, removing bloatware, and customizing system performance options.",
//         },
//         {
//           question: "How do I change settings for a company?",
//           answer:
//             "Navigate to the company management page, select a company, and switch to the 'Settings' tab. You can enable or disable specific settings based on company requirements.",
//         },
//         {
//           question: "How do I reset company settings to default?",
//           answer:
//             "To reset a company's settings to default, delete the company. When a new company is created, default settings and applications will be assigned automatically.",
//         },
//         {
//           question: "Can I apply different settings to different devices?",
//           answer:
//             "Currently, device-level settings cannot be applied individually. This feature may be added in future updates.",
//         },
//       ],
//     },
//     {
//       category: "Deployment",
//       icon: faTools,
//       items: [
//         {
//           question: "How do I initiate a deployment?",
//           answer:
//             "To initiate a deployment, run the JimmyBot - New PC Deployment script on the device from RMM or download the installer from the 'Settings' page and run it on the device.",
//         },
//         {
//           question: "What are the steps in the deployment process?",
//           answer:
//             "The deployment process involves several steps such as downloading applications, configuring settings, and optimizing the system. You can monitor the progress on the 'Deployments' page.",
//         },
//         {
//           question: "How do I download the installer?",
//           answer:
//             "To download the installer, navigate to the 'Download Installer' section. The installer includes parameters like CompanyCode, CompanyName, and SiteName. Use these to specify the deployment settings.",
//         },
//         {
//           question: "How do I install the application using command line?",
//           answer:
//             "Run the following command from the terminal: `msiexec --% /i \"path/to/ZenzeroDeployment_Installer.msi\" /l*v \"path/to/log\" CompanyName=\"Test Company\" ClientCode=TST SiteName=\"TST01 - Test\"`.",
//         },
//         {
//           question: "How do I install the application silently using PowerShell?",
//           answer:
//             "Use the following PowerShell command to install the application silently: `Start-Process msiexec -ArgumentList '/i \"path/to/ZenzeroDeployment_Installer.msi\" /qn CompanyName=\"Test Company\" ClientCode=TST SiteName=\"TST01 - Test\"' -Wait`.",
//         },
//       ],
//     },
//     {
//       category: "Notifications",
//       icon: faBell,
//       items: [
//         {
//           question: "What are system notifications?",
//           answer:
//             "System notifications alert users to important events, such as when a deployment completes or fails. Notifications are displayed on the platform and can be viewed in the notification center.",
//         },
//         {
//           question: "How do I manage notifications?",
//           answer:
//             "You can view and manage notifications by clicking the bell icon at the top of the page. Notifications can be marked as read, and you can toggle to see unread notifications only.",
//         },
//         {
//           question: "What do different notification types mean?",
//           answer:
//             "Notification types include 'Deployment Started,' 'Deployment Completed,' and 'Deployment Failed.' Each type provides real-time feedback on deployment progress.",
//         },
//       ],
//     },
//     {
//       category: "User Management",
//       icon: faUserCircle,
//       items: [
//         {
//           question: "How do I add a new user?",
//           answer:
//             "New users can sign in once given access to the JimmyBot App Registration in Azure. When the user first logs in, a profile is created. An admin can then assign additional roles to the new user if required.",
//         },
//         {
//           question: "How do I reset a user's password?",
//           answer:
//             "Users log in using 365 SSO and their Zenzero accounts. Passwords cannot be reset or viewed on the web portal.",
//         },
//         {
//           question: "How do I assign a role to a user?",
//           answer:
//             "Roles define what actions a user can perform on the platform. Navigate to Settings, and under the 'User Management' section, select the user and update their role. Available roles include Admin, Manager, and Viewer.",
//         },
//       ],
//     },
//     {
//       category: "Monitoring",
//       icon: faQuestionCircle,
//       items: [
//         {
//           question: "How can I monitor deployment progress?",
//           answer:
//             "You can monitor deployment progress in real-time through the 'Deployments' section. Each deployment will show its status, including steps like 'Downloading Google Chrome,' 'Adobe Reader Installed,' and 'Deployment Completed.'",
//         },
//         {
//           question: "What happens if a deployment fails?",
//           answer:
//             "If a deployment fails, you will see an error message in the logs. Depending on the error, you can retry the deployment or troubleshoot the issue based on the error details.",
//         },
//         {
//           question: "How do I view logs for a specific device?",
//           answer:
//             "To view logs for a specific device, navigate to the 'Device Logs' section under 'Monitoring' and select the device. You will see detailed logs for applications, system events, and errors.",
//         },
//       ],
//     },
//   ];

// // Function to add knowledge base data to Realtime Database
// function addKnowledgeBaseToRealtimeDB() {
//   const knowledgeBaseRef = ref(db, 'knowledgeBase'); // Define the reference where data will be stored

//   // Push the knowledge base data to the specified path
//   set(knowledgeBaseRef, knowledgeBaseData)
//     .then(() => {
//       console.log("Knowledge base data added to Realtime Database successfully!");
//     })
//     .catch((error) => {
//       console.error("Error adding knowledge base to Realtime Database:", error);
//     });
// }


// useEffect(() => {
//   // Call this once to add the knowledge base to the Realtime Database
//   addKnowledgeBaseToRealtimeDB();
// }, []);

  return (
    <>
      <SimplePageHeader
        iconName="settings"
        titleString="Settings"
        placeholderText="Search settings..."
        showAddButton={false}
        onSearchChange={handleSearchChange}
        searchTerm={searchTerm}
        pageType="applications"
        showDownloadButton={true}
      />
      <Box sx={{ padding: theme.spacing(4) }}>
        {/* Render the UserSettings component */}
        <UserSettings />
        
       {/* Render the AdminKnowledgeBase component */}
       <Box sx={{ padding: theme.spacing(4) }}>
        <KnowledgeBaseSettings /> {/* Add the KnowledgeBaseSettings component */}
      </Box>
      </Box>
    </>
  );
}

export default SettingsPage;
